<template lang="pug">
    a-steps(:current="active" size="small" label-placement="vertical" :initial="1")
        a-step(@click.native="forward(1)")
            a-icon(slot="icon" type="select")
            a-popover(slot="title" placement="bottom")
                span 登記必修
                template(slot="content")
                    span 系上保證上的課
                    br
                    span 點我進入該類課程清單
        a-step(@click.native="forward(2)")
            a-icon(slot="icon" type="tags")
            a-popover(slot="title" placement="bottom")
                span 抽籤必修
                template(slot="content")
                    span 要排志願序的課
                    br
                    span 點我進入該類課程清單
        a-step(@click.native="forward(3)")
            a-icon(slot="icon" type="search")
            a-popover(slot="title" placement="bottom")
                span 其他選修
                template(slot="content")
                    span 其他想修的課
                    br
                    span 點我進入該類課程清單
        //a-step(@click.native="forward(4)")
            a-icon(slot="icon" type="shopping-cart")
            a-popover(slot="title" placement="bottom")
                span 已選課程
                template(slot="content")
                    span 前面已選擇的課程
                    br
                    span 點我進入該類課程清單
</template>
<script>
    export default {
        name: 'course-selection-progress',
        props: {
            active: {}
        },
        methods: {
            forward(i) {
                this.$emit('update:active', i)
                console.log('elstep', i)
            }
        }
    }
</script>
<style>
    a-step{
        cursor:pointer;
    }
</style>